export default "assets/images/logo-disclaimer-cc1a8915.png";